export default __webpack_public_path__ + "static/media/lineD2pt.790cfe31.png";